import * as React from 'react';
import * as back from "src/assets/light-grey-terrazzo.png";
import {FruitBox} from "src/components/abstract/FruitBox";
import {MyCard} from "src/components/view/MyCard";
import {FruitShelf} from "src/containers/abstract/FruitShelf";
import {AppView} from "src/containers/view/AppView";
import {EFruits} from "src/store/enums";
import {Fruit} from "../abstract/Fruit";

class App extends React.Component {
    public render() {
        return (
            <div style={{"backgroundImage": `url(${back})`}}>
                <MyCard />

                <FruitShelf>
                    <FruitBox defaultKind={EFruits.KIWI} defaultSize={1}>
                        <Fruit kind={EFruits.LEMON} size={2}/>
                        <Fruit kind={EFruits.ORANGE} size={4}/>
                        <Fruit/>
                    </FruitBox>
                    <FruitBox defaultKind={EFruits.ORANGE} defaultSize={3}>
                        <Fruit kind={EFruits.LEMON} size={1}/>
                        <Fruit kind={EFruits.ORANGE} size={2}/>
                        <Fruit kind={EFruits.KIWI}/>
                        <Fruit/>
                    </FruitBox>
                    <FruitBox defaultKind={EFruits.LEMON} defaultSize={2}>
                        <Fruit kind={EFruits.LEMON}/>
                        <Fruit kind={EFruits.ORANGE}/>
                        <Fruit kind={EFruits.KIWI}/>
                        <Fruit/>
                        <Fruit/>
                        <Fruit/>
                    </FruitBox>
                </FruitShelf>
                <FruitShelf>
                    <FruitBox defaultKind={EFruits.KIWI} defaultSize={1}>
                        <Fruit kind={EFruits.LEMON} size={2}/>
                        <Fruit kind={EFruits.ORANGE} size={4}/>
                        <Fruit/>
                    </FruitBox>
                    <FruitBox defaultKind={EFruits.ORANGE} defaultSize={3}>
                        <Fruit kind={EFruits.LEMON} size={1}/>
                        <Fruit kind={EFruits.ORANGE} size={2}/>
                        <Fruit kind={EFruits.KIWI}/>
                        <Fruit/>
                    </FruitBox>
                </FruitShelf>
                <FruitShelf>
                    <FruitBox defaultKind={EFruits.KIWI} defaultSize={1}>
                        <Fruit kind={EFruits.LEMON} size={2}/>
                        <Fruit kind={EFruits.ORANGE} size={4}/>
                        <Fruit/>
                    </FruitBox>
                    <FruitBox defaultKind={EFruits.ORANGE} defaultSize={3}>
                        <Fruit kind={EFruits.LEMON} size={1}/>
                        <Fruit kind={EFruits.ORANGE} size={2}/>
                        <Fruit kind={EFruits.KIWI}/>
                        <Fruit/>
                    </FruitBox>
                </FruitShelf>

                <AppView/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/view/App.tsx